// Firma: "Maskeleme Düzeltmesi Bekleniyor" – mevcut belgeye maske ekle veya orijinal dosyayı yeniden seç
import { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { EyeOff, Loader2 } from 'lucide-react';
import { DocumentUploadButton } from '../employees/DocumentUploadButton';
import { MASK_FIX_LABEL, openHealthMask } from '../../lib/healthMask';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const MaskFixFirmPanel = ({ employeeId, onUploaded }) => {
  const [busy, setBusy] = useState(false);

  const addMask = async () => {
    setBusy(true);
    try {
      const res = await axios.get(`${API}/employees/${employeeId}/document-files/saglik_raporu`, { params: { which: 'latest' }, responseType: 'blob' });
      const type = res.data.type || 'application/pdf';
      const ext = type === 'application/pdf' ? 'pdf' : type === 'image/png' ? 'png' : 'jpg';
      const info = await openHealthMask({ file: new File([res.data], `saglik_raporu.${ext}`, { type }), employeeId, correction: 'add_mask' });
      if (info) onUploaded(info);
    } catch {
      toast.error('Mevcut belge açılamadı');
    }
    setBusy(false);
  };

  return (
    <div className="space-y-2 rounded-lg border-2 border-slate-800 bg-slate-50 p-3" data-testid="mask-fix-firm-panel">
      <p className="flex items-center gap-1.5 text-sm font-bold text-slate-900"><EyeOff className="h-4 w-4" />{MASK_FIX_LABEL}</p>
      <p className="text-xs text-slate-600">Eksik kalan bilgileri kapatmak için mevcut belgeye yeni siyah alan ekleyin. Gerekli bir bilgi yanlışlıkla kapatıldıysa kapatılan alan geri açılamaz; orijinal dosyayı yeniden seçip baştan maskeleyin.</p>
      <button type="button" onClick={addMask} disabled={busy} data-testid="mask-fix-add-btn"
        className="flex w-full items-center justify-center gap-2 rounded-md bg-slate-900 px-3 py-2 text-xs font-semibold text-white transition-colors hover:bg-slate-700 disabled:opacity-50">
        {busy && <Loader2 className="h-3.5 w-3.5 animate-spin" />}Mevcut Belgeye Maskeleme Ekle
      </button>
      <div className="flex">
        <DocumentUploadButton entityType="employees" entityId={employeeId} docKey="saglik_raporu" hasFile label="Orijinal Dosyayı Yeniden Seç" onUploaded={onUploaded} />
      </div>
    </div>
  );
};
